module.exports = __webpack_public_path__ + "img/Medusa_avatar.56b04f39.svg";